<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Danh sách lớp</div>
      <div class="d-flex justify-end" v-if="canConfig">
        <v-btn @click="onCreate" color="admin" class="white--text">Tạo mới</v-btn>
      </div>
    </div>
    <v-card class="pa-6 elevation-1 mb-6">
      <DocumentFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card class="elevation-1">
      <DocumentTable ref="documentTable" @onUpdate="onCreate" />
    </v-card>
    <CreateDialog ref="createDialog" />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import CreateDialog from './CreateDialog.vue'
import DocumentFilter from './ListFilter.vue'
import DocumentTable from './ListTable.vue'
export default {
  components: {DocumentFilter, DocumentTable, CreateDialog},
  computed: {
    ...mapGetters('auth', ['user']),
    canConfig() {
      return this.$helpers.ALLOWED_SETTING_ENROLL_PLAN.includes(this.user.username)
    },
  },
  async mounted() {
    let query = {}
    if (this.user.department === 'both') query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
    else query.department_in = [this.user.department, 'unset']
    await this.countItems(query)
  },
  methods: {
    ...mapActions({fetchItems: 'enrollClass/fetchItems', countItems: 'enrollClass/countItems'}),
    async onFilterChanged(data) {
      this.$loading.active = true
      await this.fetchItems({...data, _start: 0, _limit: 10})
      await this.countItems(data)
      this.$loading.active = false
    },
    onRefresh() {
      this.$refs['documentTable'].refresh()
    },
    onCreate(item = {}) {
      this.$refs['createDialog'].openDialog(item)
    },
  },
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
